module.exports = __webpack_public_path__ + "img/meiye2.6589299d.png";